import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import Layout from "../Componants/Layout";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest, putRequest } from "../services/apiMethods";
import toast from "react-hot-toast";
import AccountSuccessModal from "../Modal/ AccountSuccessModal";
import { Button } from "react-bootstrap";

export default function OtpVerification() {
    const navigate = useNavigate()
    const [show, setShow] = useState(false);
    const userId = localStorage.getItem("userId");
    const email = localStorage.getItem("email")
    const [counter, setCounter] = useState(30); // 30 sec countdown
    const [isResendDisabled, setIsResendDisabled] = useState(false);
    const { data: userDetails, error: userError, isLoading: userLoading } = useQuery({
        queryKey: ["userDetails", userId],
        queryFn: () => getRequest(`profile/info?id=${userId}`),
        enabled: !!userId,
    });

    const handleClose = () => {
        setShow(false);
        localStorage.setItem("userId", "");
        localStorage.setItem("email", "");
        navigate("/pre-registration");
    };
    const handleShow = () => setShow(true);




    const { mutate, isLoading: apiState } = useMutation({
        mutationFn: (data) => {
            return postRequest(`/auth/register`, data);
        },
        onSuccess: (data) => {
            handleShow()
            localStorage.setItem("token", data?.data?.token)
            localStorage.setItem("isPasswordSet", data?.data?.isPasswordSet);
            localStorage.removeItem("referId")
            localStorage.setItem('role', "Vendor");
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });




    const formik = useFormik({
        initialValues: {
            otp: "",
        },
        validationSchema: Yup.object({
            otp: Yup.string()
                .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
                .required("OTP is required"),
        }),
        onSubmit: (values) => {
            console.log("OTP Submitted:", values.otp);
            // Handle OTP verification logic here
            const modifyData = {
                isOtpVerified: true,
                otp: values?.otp,
                id: userId,
                role: "Vendor",
            };
            mutate(modifyData);
        },
    });


    useEffect(() => {
        let timer;
        if (isResendDisabled && counter > 0) {
            timer = setInterval(() => {
                setCounter(prev => prev - 1);
            }, 1000);
        } else if (counter === 0) {
            setIsResendDisabled(false);
            clearInterval(timer);
        }
        return () => clearInterval(timer);
    }, [counter, isResendDisabled]);



    const { mutate: resendOtpFunc, } = useMutation({
        mutationFn: (data) => {
            return postRequest("/auth/resend", data);
        },
        onSuccess: (data) => {
            if (data?.statusCode === 200) {
                // window.location.href = `${data?.data?.url}`;
            }
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });

    const handleResendOTP = async () => {

        setIsResendDisabled(true);
        setCounter(30); // Reset timer

        const payload = {
            email: email
        };
         resendOtpFunc(payload);
    };
    return (

        <Layout>
            <Container>

                <Row>
                    <Col lg={5}>
                        <div className="pre-registration">
                            <div className="my-profile-title">
                                <h4>Verify OTP</h4>
                            </div>
                            <div className="my-profile-box-contain">
                                <div className="my-profile-box-form">

                                    <Row>
                                        <Col lg={12}>
                                            <Form onSubmit={formik.handleSubmit}>
                                                <div className="form-set set-otp mb-5">
                                                    <p> We've sent a one time passcode to your email. Please enter it below to continue</p>
                                                    <OtpInput
                                                        value={formik.values.otp}
                                                        onChange={(value) => formik.setFieldValue("otp", value)}
                                                        numInputs={6}
                                                        isInputNum
                                                        inputType="tel"
                                                        renderInput={(props) => <input {...props} />}
                                                    />
                                                    {formik.touched.otp && formik.errors.otp && (
                                                        <div className="text-danger">{formik.errors.otp}</div>
                                                    )}
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="verify-button">
                                                        Verify
                                                    </button>
                                                    {/* <a href="#" className="resend-link">
                                                        Resend OTP
                                                    </a> */}
                                                 
                                                        <a className="resend-link" onClick={() => handleResendOTP()}
                                                            disabled={isResendDisabled}>
                                                            {isResendDisabled ? `Resend in ${counter}s` : "Resend OTP"}
                                                        </a> 
                                                 


                                                </div>
                                            </Form>
                                        </Col>
                                       
                                    </Row>
                                </div>
                            </div>
                        </div>

                    </Col>
                </Row>
            </Container>
            <AccountSuccessModal show={show} handleClose={handleClose} />
        </Layout>
    );
}
